import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {
  Typography,
  Box,
  TextField,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  OutlinedInput,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TablePagination,
  Hidden,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EmptyTransparentCard from "../../components/StaticComp/EmptyTransparentCard/EmptyTransparentCard";
import SingleItem from "../../components/StaticComp/LandingPageFeature/LandingPageFeature";
import banner from "../../assets/staticAssets/banner.svg";
import bannerMobile from "../../assets/staticAssets/PB_Rewards_Mobile.png";
import useResizer from "../../services/useResizer";

import getYourLink from "../../assets/staticAssets/getYourLink.svg";
import inviteFriends from "../../assets/staticAssets/inviteFriends.svg";
import earnReward from "../../assets/staticAssets/earnReward.svg";
import getYourLink_light from "../../assets/staticAssets/getYourLink_light.svg";
import inviteFriends_light from "../../assets/staticAssets/inviteFriends_light.svg";
import earnReward_light from "../../assets/staticAssets/earnReward_light.svg";
import email from "../../assets/staticAssets/email.svg";
import facebook from "../../assets/staticAssets/facebook.svg";
import telegram from "../../assets/staticAssets/telegram.svg";
import twitter from "../../assets/staticAssets/twitter.svg";
import whatsapp from "../../assets/staticAssets/whatsapp.svg";
import { CoinContext } from "../../contexts/CoinContext";
import { MdContentCopy } from "react-icons/md";
import { REACT_APP_PROD_URL } from "../../services/configs";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import { copyTextAndSendToApp } from "../../services/appMethods";
import * as styles from "./Invite.module.css";
import BonusTable from "../../components/BonusTable";
import { useQuery } from "react-query";

export default function Invite() {
  const classes = useStyles();
  let history = useHistory();
  const theme = useTheme();
  const isMobile = useResizer();
  const token = useSelector((state) => state.trading.TOKEN);

  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);

  const [referral, setReferral] = useState("");
  const [refHistory, setRefHistory] = useState(null);
  const [totals, setTotals] = useState({
    commission: 0,
    referred: 0,
    totalApprovedKyc: 0,
  });

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(9);

  useEffect(() => {
    setStartIndex(rowsPerPage * page);
    setEndIndex(rowsPerPage * page + rowsPerPage - 1);
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (token) {
      fetcher(`/v1/um/getReferral`)
        .then((data) => {
          // console.log(data);
          if (data.referralCode) {
            setReferral(data.referralCode);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });

      // console.log("Getting INR balance");
    }
  }, []);

  useEffect(() => {
    if (token) {
      fetcher(
        `/v1/commissionHistory?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}`
      )
        .then((data) => {
          if (data.details.content) {
            console.log(data.details);
            setRefHistory(data.details);
            setTotals({
              commission: data.totalCommission,
              referred: data.totalReferred,
              totalApprovedKyc: data.totalApprovedKyc,
            });
          }
          // console.log("Notifications", data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting notifications");
    }
  }, [page, rowsPerPage]);

  const bonusStats = useQuery(["bonusStats"], () =>
    fetcher("/v1/bonus/stats").then((res) => res)
  );

  return (
    <div className="">
      {/* <Typography
        style={{ marginBottom: "5px", fontSize: "40px", fontWeight: "bold" }}
      >
        Invite
      </Typography> */}
      <Hidden mdDown>
        <div style={{ marginBottom: "15px", width: "100%" }}>
          <img src={banner} alt="banner" style={{ width: "100%" }} />
        </div>
      </Hidden>
      <Hidden mdUp>
        <div style={{ marginBottom: "15px", width: "100%" }}>
          <img src={bannerMobile} alt="banner" style={{ width: "100%" }} />
        </div>
      </Hidden>
      <Box
        className="sm:flex hidden mb-10"
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        textAlign="center"
        justifyContent="space-between"
        height="100%"
        width="85%"
        margin="0 auto"
      >
        <EmptyTransparentCard careers>
          <SingleItem
            careers
            invite
            image={
              theme.palette.type === "dark" ? getYourLink : getYourLink_light
            }
            title="Get Your Link"
            text="Share your unique referral link and earn on trades of every user that use your link to sign up."
          />
        </EmptyTransparentCard>
        <EmptyTransparentCard careers>
          <SingleItem
            careers
            invite
            image={
              theme.palette.type === "dark"
                ? inviteFriends
                : inviteFriends_light
            }
            title="Invite Friends"
            text="Invite friends and family to a zero-fee trading experience. Share your link via Social Media, Emails or Messaging apps. The more you invite the more you earn!"
          />
        </EmptyTransparentCard>
        <EmptyTransparentCard careers>
          <SingleItem
            careers
            invite
            image={
              theme.palette.type === "dark" ? earnReward : earnReward_light
            }
            title="Earn Rewards"
            text="You will earn 0.1% of every trades total amount that your referral does. Earning beyond trade fees is now possible!"
          />
        </EmptyTransparentCard>
      </Box>
      <div className="flex flex-col gap-6 mb-6 sm:gap-10">
        <div className="sm:hidden flex flex-nowrap w-full justify-between min-h-[50px]">
          <div
            className="flex gap-2 items-center w-1/2"
            style={{ borderRight: "1px solid #343844" }}
          >
            <p className="opacity-60">Bonus Locked</p>
            <h3> ₹{bonusStats.data?.lockedBonus || "0"}</h3>
          </div>
          <div className="flex gap-2 items-center w-1/2 justify-end">
            <p className="opacity-60">Bonus Earned</p>
            <h3> ₹{bonusStats.data?.earnedBonus || "0"}</h3>
          </div>
        </div>
        <div className="order-last sm:order-first flex flex-col  gap-3 justify-center w-full items-center bg-[#282C37] sm:bg-transparent rounded-[16px] p-4 sm:p-0 ">
          <div
            className="rounded-[8px] w-full sm:max-w-md flex justify-between items-stretch"
            style={{ background: " rgba(77, 83, 97, 0.3)", color: "#A6ABB9" }}
          >
            <h4 className="p-3">Referral Code</h4>
            <div className="flex items-center">
              <h4 className="font-light mr-4">{referral}</h4>
              <Button
                className="h-full text-white font-bold"
                color="primary"
                variant="contained"
                onClick={() => {
                  let text = referral;
                  navigator.clipboard.writeText(text);
                  copyTextAndSendToApp(text);
                  handleClickAlert("success", "Referral code copied!");
                }}
              >
                Copy
              </Button>
            </div>
          </div>
          <div
            className="rounded-[8px] w-full sm:max-w-md flex justify-between items-stretch "
            style={{ background: " rgba(77, 83, 97, 0.3)", color: "#A6ABB9" }}
          >
            <h4 className="p-3 whitespace-nowrap">Referral Link</h4>
            <div className="flex items-center overflow-hidden ">
              <div className="relative ">
                <h4
                  className={`font-light mr-4 whitespace-nowrap max-w-[120px]  sm:max-w-[200px] overflow-hidden`}
                >{`${window.location.origin}/?ref=${referral}&utm_source=s&utm_medium=rl&utm_id=r`}</h4>

                <div className={` ${styles.fade} `}></div>
              </div>

              <Button
                className="h-full text-white font-bold"
                color="primary"
                variant="contained"
                onClick={() => {
                  let text = `${window.location.origin}/?ref=${referral}&utm_source=s&utm_medium=rl&utm_id=r`;
                  navigator.clipboard.writeText(text);
                  copyTextAndSendToApp(text);
                  handleClickAlert("success", "Referral link copied!");
                }}
              >
                Copy
              </Button>
            </div>
          </div>
        </div>
        <div className="w-full  flex justify-center ">
          <BonusTable></BonusTable>
        </div>
      </div>
      {/* <div className={classes.mediaHolder}>
        <img className={classes.mediaIcon} src={twitter} alt="twitter" />
        <img className={classes.mediaIcon} src={email} alt="email" />
        <img className={classes.mediaIcon} src={facebook} alt="fb" />
        <img className={classes.mediaIcon} src={whatsapp} alt="whatsapp" />
        <img className={classes.mediaIcon} src={telegram} alt="telegram" />
      </div> */}

      <div className="">
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className={classes.table}>
              <div
                className="mb-0"
                style={{
                  margin: "18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginBottom: "10px",
                  }}
                >
                  Referral History
                </p>
              </div>
              <div
                className="mb-4 flex flex-wrap flex-col sm:flex-row gap-y-2 items-start sm:justify-between"
                style={{
                  margin: "0px 18px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div
                  className="flex justify-between w-full  sm:w-max"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "8px",
                  }}
                >
                  <p
                    className="font-light"
                    style={{ fontSize: "14px", marginRight: "8px" }}
                  >
                    Referrals
                  </p>

                  <div className={classes.numBox}>{totals.referred}</div>
                </div>
                <div
                  className="flex justify-between w-full sm:w-max"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "8px",
                  }}
                >
                  <p
                    style={{ fontSize: "14px", marginRight: "8px" }}
                    className="font-light"
                  >
                    Approved
                  </p>

                  <div className={classes.numBox}>
                    {totals.totalApprovedKyc}
                  </div>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className="flex justify-between w-full  sm:w-max"
                >
                  {" "}
                  <p
                    className="font-light"
                    style={{
                      fontSize: "14px",
                      marginRight: "8px",
                    }}
                  >
                    Rewards
                  </p>
                  <div className={classes.numBox}>₹{totals.commission}</div>
                </div>
              </div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  borderBottom:
                    theme.palette.type === "dark"
                      ? "1px solid #40454F"
                      : "1px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <thead
                  className={`${classes.tableBorders} ${classes.flexContainer}`}
                >
                  <th className={classes.headerText}>
                    <Typography>
                      <strong>Date</strong>
                    </Typography>
                  </th>
                  <th
                    className={classes.headerText}
                    style={{
                      borderLeft:
                        theme.palette.type === "dark"
                          ? "1px solid #40454F"
                          : "1px solid rgba(0, 0, 0, 0.1)",
                      borderRight:
                        theme.palette.type === "dark"
                          ? "1px solid #40454F"
                          : "1px solid rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography>
                      <strong>Email ID</strong>
                    </Typography>
                  </th>
                  <th className={classes.headerText}>
                    <Typography>
                      <strong>Rewards Earned</strong>
                    </Typography>
                  </th>
                </thead>

                {refHistory
                  ? refHistory.content
                      .sort((a, b) => {
                        return Date.parse(b.at) - Date.parse(a.at);
                      })
                      .filter((data, index) => {
                        return index >= startIndex && index <= endIndex;
                      })
                      .map((row) => (
                        <tr className={classes.flexContainer}>
                          <td>
                            {row.at.slice(8, 10)}.{row.at.slice(5, 7)}.
                            {row.at.slice(0, 4)} {row.at.slice(11, 16)}
                          </td>
                          <td className={classes.tableCell}>
                            {row.commissionFromEmail}
                          </td>
                          <td>{row.commission}</td>
                        </tr>
                      ))
                  : null}
              </table>

              {refHistory ? (
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  component="div"
                  count={refHistory.numberOfElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              ) : null}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.accordianCard}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                  alignItems: "center",
                }}
              >
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>FAQ</p>
                <p
                  className={classes.link}
                  onClick={() => {
                    window.open(
                      "https://support.pocketbits.in/support/solutions",
                      "_blank",
                      "nofollow,noopener,noreferrer"
                    );
                  }}
                >
                  View All
                </p>
              </div>

              <div>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.heading}>
                      How much can I earn?
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      We give you the freedom to earn on every trade that your
                      referral does. You will get 0.1% of their total trade
                      value; even when you are asleep. The earnings are never
                      limited!
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.heading}>
                      How are the referral rewards credited to me?
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      All referral rewards are added instantly. No hassle of
                      waiting for a 24hours cycle to get the rewards credited.
                      Every time your referral trades the reward is credited to
                      your INR wallet in real-time.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography className={classes.heading}>
                      How long is this Referral valid for?
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      PocketBits has the right to make changes to the referral
                      and rewards programs. The current refer and earn of 0.1%
                      is valid till 31st December, 2023.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    marginTop: "20px",
    paddingTop: "16px",
    paddingBottom: "16px",
    display: "flex",
    alignItems: "center",
  },
  grow: {
    flexGrow: 1,
  },
  copyIcon: {
    fontSize: "20px",
    // marginRight: "16px",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
  mediaHolder: {
    marginTop: "20px",
    marginBottom: "40px",

    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-evenly",
    [theme.breakpoints.up("sm")]: {
      width: "30%",
    },
  },
  mediaIcon: {
    width: "45px",
    height: "auto",
    "&:hover": {
      [theme.breakpoints.down("sm")]: {
        transform: "scale(1.05,1.05)",
      },
      transform: "scale(1.15,1.15)",
      cursor: "pointer",
    },
  },
  table: {
    // background: "#1D212D",
    // width: "60%",
    color: theme.palette.text.primary,
    borderRadius: "20px",
    overflow: "hidden",
    // boxShadow: "10px 20px 30px rgba(5, 15, 26, 0.5)",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#ffffff",
    boxShadow:
      theme.palette.type === "dark"
        ? "40px 60px 200px rgba(16, 18, 26, 0.5)"
        : "6px 4px 12px -1px rgba(109, 227, 206, 0.2)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    // float: "left",
    margin: "10px 0px",
    position: "relative",
    // [theme.breakpoints.down("md")]: {
    //   "&:after": {
    //     content: "''",
    //     position: "absolute",
    //     zIndex: 1,
    //     top: "0",
    //     right: "0",
    //     bottom: "15px",
    //     pointerEvents: "none",
    //     backgroundImage:
    //       theme.palette.type === "dark"
    //         ? "linear-gradient(to right,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1))"
    //         : "linear-gradient(to right, rgba(255, 255, 255, 0), #999 85%)",
    //     width: "15%",
    //   },
    // },
  },
  tableBorders: {
    // background: "#252933",
    borderTop:
      theme.palette.type === "dark"
        ? "1px solid #40454F"
        : "1px solid rgba(0, 0, 0, 0.1)",
  },
  tableCell: {
    borderLeft:
      theme.palette.type === "dark"
        ? "1px solid #40454F"
        : "1px solid rgba(0, 0, 0, 0.1)",
    borderRight:
      theme.palette.type === "dark"
        ? "1px solid #40454F"
        : "1px solid rgba(0, 0, 0, 0.1)",
  },
  topText: {
    textAlign: "center",
    paddingBottom: "20px",
  },
  headerText: {
    height: "50px",
    color: "#3AC4AB",
  },
  button: {
    color: "#fff",
    borderRadius: "15px",
  },
  flexContainer: {
    textAlign: "center",
    height: "50px",
    borderTop:
      theme.palette.type === "dark"
        ? "1px solid #40454F"
        : "1px solid rgba(0, 0, 0, 0.1)",
  },
  numBox: {
    // width: "70px",
    // height: "40px",
    background: theme.palette.type === "dark" ? "#1B202D" : "#eee",
    borderRadius: "4px",
    textAlign: "center",
    fontWeight: "bold",
    padding: "5px 10px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  accordianCard: {
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#ffffff",
    boxShadow:
      theme.palette.type === "dark"
        ? "40px 60px 200px rgba(16, 18, 26, 0.5)"
        : "6px 4px 12px -1px rgba(109, 227, 206, 0.2)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    // width: "35%",
    borderRadius: "25px",
    padding: "20px",
    float: "right",
    margin: "10px",
  },
  accord: {
    borderRadius: "12px",
    // marginBottom: "15px"
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
}));
